exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b511abd6] .numrule input::-webkit-outer-spin-button,[data-v-b511abd6] .numrule input::-webkit-inner-spin-button{-webkit-appearance:none !important}[data-v-b511abd6] .numrule input[type=number]{-moz-appearance:textfield !important}", ""]);

// exports
